import React, { useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataModalSuccessMsg } from '../../../../redux/actions/partials/modals/modalSuccessMsg';
import { actionRemoveAllItemFromShoppingCart } from '../../../../redux/actions/shoppingCart';
import useOutsideClick from './hooks/useOutsideClick'; 


const ModalSuccessMsg = (props) => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { isMobile } = useSelector(state => state.general);
	const { isActive } = useSelector(state => state.modalSuccessMsg);


	const handleClose = () => {
		dispatch(actionRemoveAllItemFromShoppingCart());

		dispatch(handleChangeDataModalSuccessMsg('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalSuccessMsg('isOpen', false));
        }, 250);
    };    

    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalSuccessMsg]);



    const handleOkBtn = () => {
    	navigate('profile/orders');
    	handleClose();
    };



    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '460px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '59px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="420" height="58.59375">
						<div className="flex items-center border-complete-b-200">
							<div className="break-words py-3 grow">
								<div className="flex items-center grow">
									<p className="grow text-h5 text-neutral-900">
										<span className="relative">ثبت سفارش
										</span>
									</p>
								</div>
							</div>
							<div className="grow text-h5">
							</div>
							<div className="flex cursor-pointer" onClick={handleOkBtn}>
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							<div>
								<p className="text-body-1 text-neutral-900 mb-4">سفارش شما با موفقیت ثبت شد و در تاریخ و زمان انتخابی ارسال خواهد شد.
								</p>
								<div className="flex flex-row lg:justify-end gap-3">
									<button onClick={handleOkBtn} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium">
										<div className="flex items-center justify-center relative grow">باشه
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalSuccessMsg;
